import Vue from 'vue';
import { mapGetters } from 'vuex';
import HTTPRetryUtil from 'src/utils/httpretry';
import ExportDataAccess from 'components/account/ExportAPI/ExportDataAccess.vue';
import SiteTokenConfiguration from 'components/account/ExportAPI/SiteTokenConfiguration.vue';
import IPAllowList from 'components/account/ExportAPI/IPAllowList.vue';
export default Vue.extend({
    components: {
        ExportDataAccess,
        SiteTokenConfiguration,
        IPAllowList,
    },
    data() {
        return {
            activeName: 'exports',
            ipAllowedData: [],
            tokenData: [],
            exportData: [],
            newTokenDialogVisible: false,
            newToken: '',
            loading: false,
        };
    },
    computed: {
        ...mapGetters(['currentSite']),
    },
    beforeMount() {
        this.refreshAll();
    },
    methods: {
        async configurePrefix(action, item) {
            if (action === 'Add') {
                await Vue.http.post('ipprotection/export/configuration/ip', { ipv4_prefix: item });
            }
            else if (action === 'Edit') {
            }
            else if (action === 'Delete') {
                await Vue.http.delete(`ipprotection/export/configuration/ip/${item.id}`);
            }
            this.fetchIPPrefixData();
        },
        async fetchIPPrefixData() {
            let data = await HTTPRetryUtil.retry('ipprotection/export/configuration/ip');
            this.ipAllowedData = data;
        },
        async configureToken(action, item) {
            if (action === 'Add') {
                let response = await Vue.http.post('apitokens/export/configuration/token');
                let data = await response.json();
                this.newToken = data.token;
                this.newTokenDialogVisible = true;
            }
            else if (action == 'Delete') {
                await Vue.http.delete(`apitokens/export/configuration/token/${item.id}/`);
            }
            this.fetchTokenData();
        },
        async fetchTokenData() {
            let data = await HTTPRetryUtil.retry('apitokens/export/configuration/token');
            this.tokenData = data;
        },
        async copyTokenToClipboardAndCloseDialog() {
            try {
                // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
                await navigator.clipboard.writeText(this.newToken);
            }
            finally {
                this.newToken = '';
                this.newTokenDialogVisible = false;
            }
        },
        async configureExport(item) {
            await Vue.http.put(`export/configuration/analysis/${item.analysis_id}/`);
            this.fetchExportData();
        },
        async fetchExportData() {
            this.exportData = await HTTPRetryUtil.retry('export/configuration/list');
        },
        async refreshAll() {
            this.loading = true;
            try {
                await Promise.all([
                    this.fetchExportData(),
                    this.fetchTokenData(),
                    this.fetchIPPrefixData(),
                ]);
            }
            finally {
                this.loading = false;
            }
        }
    },
});
